import SiteEvents, { SiteEventNames } from '../util/site-events';

class MobileMenu {
	constructor(el) {
		this.el = el;
		this.panelEls = Array.from(this.el.querySelectorAll('.menu-dropdown__mobile-panel'));

		// add event handlers to all show panel triggers
		const panelTriggerEls = Array.from(this.el.querySelectorAll('[data-mobile-panel-show]'));

		panelTriggerEls.forEach((btnEl) => {
			btnEl.addEventListener('click', (e) => {
				e.preventDefault();

				const showPanelId = e.currentTarget.getAttribute('data-mobile-panel-show') ?? '0';

				this.setVisiblePanel(showPanelId);
			});
		});
	}

	setVisiblePanel(panelName) {
		this.panelEls.forEach((panelEl) => {
			const panelId = panelEl.getAttribute('data-mobile-panel-id');

			if (panelId === panelName) {
				panelEl.classList.add('active');
			} else {
				panelEl.classList.remove('active');
			}
		});

		SiteEvents.publish(SiteEventNames.IMAGEBUDDY_TRIGGER_UPDATE);
	}
}

export default MobileMenu;
